export default __webpack_public_path__ + "static/media/Gold-Stitched Gloves.a578574d.jpg";